import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Megaphone } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const DmCta: React.FC = () => (
  <AnimatedSection as="section" className="dm-cta" aria-labelledby="dm-cta-title">
    <div className="dm-container">
      <motion.div
        className="dm-cta__inner"
        whileHover={{ scale: 1.005 }}
        transition={{ duration: 0.3 }}
      >
        <div className="dm-cta__icon" aria-hidden="true">
          <Megaphone size={32} />
        </div>
        <div className="dm-cta__text">
          <h2 id="dm-cta-title">Ready To Grow Your Business Online?</h2>
          <p>Let&apos;s build a digital marketing strategy that delivers real results.</p>
        </div>
        <div className="dm-cta__actions">
          <Link to="/contact" className="dm-cta__btn dm-cta__btn--primary">
            Get Free Strategy Call
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link to="/contact" className="dm-cta__btn dm-cta__btn--ghost">
            Request a Quote
          </Link>
        </div>
      </motion.div>
    </div>
  </AnimatedSection>
);

export default DmCta;
